import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import {
  onWebsocketMessageDispatchUpdateEntities,
  onWebsocketMessageDispatchAddRemoveEntities
} from '@zerops/zef/entities';
import { UserEntity } from '@zerops/zerops/core/user-base';
import { TransactionCreditEntity } from './transaction-credit.entity';

@Injectable()
export class TransactionCreditBaseEffect {

  private _setupListStreamTransactionCredit$ = createEffect(() => this._userEntity.activeClientId$.pipe(
    map((clientId) => this._transactionCreditEntity.listSubscribe(clientId))
  ));

  private _setupAddRemoveMessage$ = createEffect(() => this._actions$.pipe(
    onWebsocketMessageDispatchAddRemoveEntities(this._transactionCreditEntity)
  ));

  private _setupUpdateStreamSubscription$ = createEffect(() => this._userEntity.activeClientId$.pipe(
    map((clientId) => this._transactionCreditEntity.updateSubscribe(clientId)
  )));

  private _onUpdateStreamMessage$ = createEffect(() => this._actions$.pipe(
    onWebsocketMessageDispatchUpdateEntities(this._transactionCreditEntity)
  ));

  constructor(
    private _actions$: Actions,
    private _transactionCreditEntity: TransactionCreditEntity,
    private _userEntity: UserEntity
  ) {}
}
